import './index.css'
import * as React from 'react'
import type { EmailElement } from 'types/content-editor'
import ButtonBlock from './button-block'
import DividerBlock from './divider-block'
import FooterBlock from './footer-block'
import ImageBlock from './image-block'
import PlaylistBlock from './playlist-block'
import TextBlock from './text-block'
const componentMap = {
  text: TextBlock,
  image: ImageBlock,
  footer: FooterBlock,
  playlist: PlaylistBlock,
  button: ButtonBlock,
  divider: DividerBlock,
}
type ElementProps = Record<string, any> // `DividerProps`, `ImageProps`, etc

const EmailElementComponent = ({
  component,
  ...rest
}: ElementProps & {
  component: EmailElement
}): React.ReactElement<'div'> => {
  const { type, ...params } = component
  const Element = componentMap[type]
  if (Element)
    return (
      <div className="content-editor__email-block">
        <Element {...params} {...rest} />
      </div>
    )
  throw new Error(`Unknown element type: ${component.type}`)
}

export default EmailElementComponent
